const DEFAULT_TIMEZONE = 'UTC';

function isValidTimezone(timezone?: string | null): timezone is string {
  if (!timezone || typeof timezone !== 'string') return false;
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: timezone }).format(new Date());
    return true;
  } catch {
    return false;
  }
}

function getDateParts(date: Date, timezone: string) {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  const year = parts.find((p) => p.type === 'year')?.value ?? '0000';
  const month = parts.find((p) => p.type === 'month')?.value ?? '01';
  const day = parts.find((p) => p.type === 'day')?.value ?? '01';
  return { year, month, day };
}

export function resolveSiteTimezone(site: any): string {
  const candidates = [
    site?.timezone,
    site?.location?.timezone,
    site?.weather?.timezone,
    site?.weatherTimezone,
  ];

  for (const candidate of candidates) {
    if (isValidTimezone(candidate)) return candidate;
  }

  return DEFAULT_TIMEZONE;
}

export function formatSiteDate(date: Date, timezone: string): string {
  const tz = isValidTimezone(timezone) ? timezone : DEFAULT_TIMEZONE;
  const { year, month, day } = getDateParts(date, tz);
  return `${year}-${month}-${day}`;
}

export function formatSiteTime(date: Date, timezone: string): string {
  const tz = isValidTimezone(timezone) ? timezone : DEFAULT_TIMEZONE;
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: tz,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  }).format(date);
}
